import View from "../../../assets/js/view";
export default class FlexibleContent extends View {
  ui = {
    sad: ".fc-change-with-previous",
  };

  events = {};

  init() {
    console.log("tetstataa");
  }
}
